<script>
import {emitter} from "@/eventHub";
import LinkInvoiceToSupplierInvoice from "@/Components/SlideOuts/LinkInvoiceToSupplierInvoice";
import AddSupportingDocumentation from "@/Components/SlideOuts/AddSupportingDocumentation";

export default {
    emits: ['checkedLines'],
    components: {
        LinkInvoiceToSupplierInvoice,
        AddSupportingDocumentation
    },
    props: {
        invoices: Object,
        display_related_quotes: {
            type: Boolean,
            default: false
        },
        invoice_type: {
            type: String,
            default: "Invoice"
        },
        quote: Object,
        service_lines: Object
    },
    data() {
        return {
            emitter: emitter,
            showErrors: false,
            selectedLines: []
        }
    },
    methods: {
        test() {
            alert('ok');
        },
        toggleServiceLineSelection() {
            if (!this.selectAll) {
                // Select all
                this.selectedLines = this.service_lines.map(line => line.id);
                this.selectAll = true;
            } else {
                // Deselect all
                this.selectedLines = [];
                this.selectAll = false;
            }
            this.$emit('checkedLines', this.selectedLines);
        }
    }
}
</script>

<template>
    <div class="space-y-6 pb-5">
        <div class="flex flex-col mt-2">
            <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                    <div class="relative overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg block" style="max-height: 750px;overflow-y: scroll;">
                        <table class="min-w-full table-fixed divide-y divide-gray-300">
                            <thead class="bg-gray-50">
                                <tr>
                                    <th scope="col" class="min-w-[12rem] py-3.5 pl-5 text-left text-sm font-semibold text-gray-900">
                                        <div class="absolute inset-y-0 left-0 w-0.5 bg-pitch-purple"></div>
                                        <div class="flex items-center pl-1">
                                            <input
                                                id="toggleServiceLineSelection"
                                                type="checkbox"
                                                class="w-4 h-4 rounded border-gray-300 text-pitch-purple focus:ring-indigo-500 sm:left-6"
                                                @click="toggleServiceLineSelection"
                                            />
                                            <label for="toggleServiceLineSelection" class="ml-2 text-sm font-medium text-black">
                                                <span v-if="!this.selectAll">Select All</span>
                                                <span v-else>Deselect All</span>
                                            </label>
                                        </div>
                                    </th>
                                    <th scope="col" class="min-w-[12rem] py-3.5 pr-3 text-left text-sm font-semibold text-gray-900">Folder</th>
                                    <th scope="col" class="min-w-[12rem] py-3.5 pr-3 text-left text-sm font-semibold text-gray-900">Supplier</th>
                                    <th scope="col" class="min-w-[12rem] py-3.5 pr-3 text-left text-sm font-semibold text-gray-900">Item</th>
                                    <th scope="col" class="min-w-[12rem] py-3.5 pr-3 text-left text-sm font-semibold text-gray-900">Cost</th>
                                    <th scope="col" class="min-w-[12rem] py-3.5 pr-3 text-left text-sm font-semibold text-gray-900">Sell</th>
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 bg-white">
                                <tr v-for="service_line in service_lines" :key="service_line?.id">
                                    <td class="relative w-12 px-6 sm:w-16 sm:px-8">
                                        <div class="absolute inset-y-0 left-0 w-0.5 bg-pitch-purple"></div>
                                        <input type="checkbox" class="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-pitch-purple focus:ring-indigo-500 sm:left-6" :value="service_line.id" v-model="selectedLines" @change="$emit('checkedLines', selectedLines)" />
                                    </td>
                                    <td class="whitespace-nowrap py-4 pr-3 text-sm font-medium">
                                        {{ service_line?.folder?.name }}
                                    </td>
                                    <td class="whitespace-nowrap py-4 pr-3 text-sm font-medium">
                                        {{ service_line?.supplier?.name }}
                                    </td>
                                    <td class="whitespace-nowrap py-4 pr-3 text-sm font-medium">
                                        {{ service_line?.name }}
                                    </td>
                                    <td class="whitespace-nowrap py-4 pr-3 text-sm font-medium">
                                        <span v-if="quote">
                                            {{ formatCurrency(service_line.buy_gross_total, quote.buy_currency.code ?? 'gbp', true) }}
                                        </span>
                                        <span v-else>
                                            {{ parseFloat(service_line.buy_gross_total).toFixed(2) }}
                                        </span>
                                    </td>
                                    <td class="whitespace-nowrap py-4 pr-3 text-sm font-medium">
                                        <span v-if="quote">
                                            {{ formatCurrency(service_line.sell_gross_total, quote.sell_currency.code ?? 'gbp', true) }}
                                        </span>
                                        <span v-else>
                                            {{ parseFloat(service_line.sell_gross_total).toFixed(2) }}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
